const measurementId = 'G-BP1QKT06Z7';

function hasCredentials(value) {
  if (!value) return false;
  const url = new URL(value);
  const hash = new URLSearchParams(url.hash.slice(1));
  return (
    ['apiToken', 'token', 'refreshToken'].some(
      key => url.searchParams.has(key) || hash.has(key)
    ) || /^\/Forgotten\/reset\//i.test(url.pathname)
  );
}

export function isCheckoutUrl(value, origin) {
  try {
    const path = decodeURIComponent(new URL(value, origin).pathname).replace(
      /\\/g,
      '/'
    );
    return /^\/+checkout(?:[\/;]|$)/i.test(path);
  } catch {
    return true;
  }
}

export function createAnalytics(browser) {
  const origin = browser.location.origin;
  const checkoutDocument = isCheckoutUrl(browser.location.href, origin);
  let started = false;
  let restoreAfterNavigation;

  // Back/Forward can restore the old document, including its disabled GA flag.
  browser.addEventListener('pageshow', event => {
    if (event.persisted) restoreAfterNavigation?.();
  });

  return {
    start() {
      if (
        started ||
        checkoutDocument ||
        isCheckoutUrl(browser.location.href, origin)
      ) {
        return;
      }

      // Let login remove SSO credentials before Google can read the page URL.
      if (hasCredentials(browser.location.href)) return;

      started = true;
      browser.dataLayer = browser.dataLayer || [];
      browser.gtag = function () {
        browser.dataLayer.push(arguments);
      };
      browser.gtag('js', new Date());
      if (hasCredentials(browser.document.referrer)) {
        browser.gtag('set', 'page_referrer', '');
      }
      browser.gtag('config', measurementId);

      const script = browser.document.createElement('script');
      script.async = true;
      script.referrerPolicy = 'no-referrer';
      script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
      browser.document.head.appendChild(script);
    },

    allowNavigation(url) {
      if (checkoutDocument === isCheckoutUrl(url, origin)) return true;

      // Angular navigation must not carry an already-loaded GA tag into checkout.
      const previousDisableState = browser[`ga-disable-${measurementId}`];
      restoreAfterNavigation = () => {
        browser[`ga-disable-${measurementId}`] = previousDisableState;
      };
      browser[`ga-disable-${measurementId}`] = true;
      browser.location.assign(url);
      return false;
    },
  };
}

export const analytics = createAnalytics(window);
